<template>
  <div class="d-flex game-container">
    <iframe
      v-if="url"
      :src="url"
      style="flex: 1; border: none"
      class="w-100 h-100"
    >
    </iframe>
    <span v-else>
      {{ $t("Game not found") }}
    </span>
  </div>
</template>
<script>
import gameService from "@/services/gameService";
import dialogHelper from "@/helpers/dialogHelper";
import qs from "qs";

export default {
  name: "PlayH5",
  data: () => ({
    url: undefined,
  }),
  methods: {
    async loadGame() {
      const accessToken = this.$store.getters.accessToken;
      if (!accessToken?.length) {
        await this.$router.push({ name: "SignIn" });
        return;
      }

      const { aliasUrl } = this.$route.params;
      if (!aliasUrl?.length) {
        await this.$gotoHomePage();
        return;
      }

      const storageKey = `game:${aliasUrl}`;
      try {
        const json = window.sessionStorage.getItem(storageKey);
        if (json?.length) {
          this.setGameUrl(JSON.parse(json), accessToken);
          return;
        }
      } catch (e) {
        console.log(e);
      }

      const response = await gameService.detail(aliasUrl);
      if (!response || response.error) {
        await dialogHelper.alert(
          response?.message ??
            "Connect to server failed. Please check your internet connection"
        );
        await this.$gotoHomePage();
        return;
      }

      var game = response.data;
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify(game));
      } catch (e) {
        await this.$gotoHomePage();
        return;
      }

      this.setGameUrl(game, accessToken);
    },
    setGameUrl(game, accessToken) {
      const query = qs.stringify({ accessToken });
      let gameUrl = game.gameUrl;
      gameUrl += !gameUrl.includes("?") ? "?" : "&";
      this.url = gameUrl + query;
    },
  },
  async created() {
    await this.loadGame();
  },
};
</script>
<style lang="scss">
#app {
  .app-width {
    width: 100%;
  }

  .app-toolbar {
    display: none;
  }

  .game-container {
    height: calc(100% - 62px);
    align-items: center;
    justify-content: center;
  }
}
</style>
